import { useAutoAnimate } from "@formkit/auto-animate/react"
import React from "react"

interface InputProps {
	props?: any
	className?: string | null
	label?: string | null
	errMsg?: string
	hasError?: boolean
}

const ElemSelect: React.FC<InputProps> = ({ className, props, label, errMsg, hasError, children }) => {
	const [animationRef] = useAutoAnimate<HTMLDivElement>()
	return (
		<>
			<span className={"pointer-events-none mt-1 block  pb-1 pt-1 pl-2 text-[13px] text-white" + (hasError ? "  text-white" : " text-white ")}>{label}</span>
			<label
				className={
					"relative block after:pointer-events-none after:absolute after:right-[20px] after:top-[20px] after:h-[15px] after:w-[15px] after:bg-[url(/src/bgimages/arrow-down.svg)] after:bg-contain after:bg-no-repeat after:content-['']" +
					(className || "")
				}
			>
				<select
					className={
						"  text-bold text-y outline- peer relative mb-2 w-full appearance-none  rounded-full bg-white  bg-[160px_20px] bg-no-repeat py-3 px-4 font-Alpro uppercase  text-blue shadow-inner " +
						(hasError ? "  js-formerror " : "")
					}
					{...props}
				>
					{children}
				</select>
				<div ref={animationRef}>{hasError && <div className="formErrorMsg mb-2 inline bg-whiteLight75  px-2 py-1 text-[12px] font-bold text-errorred">{errMsg}</div>}</div>
			</label>
		</>
	)
}

export default ElemSelect
